/* @ngInject */
const invoicingCtrl = (
  $scope,
  excelLoader,
  valueHandler,
  $$wagon,
  utils,
  labels,
) => {
  $scope.myInvoice = {}
  // $scope.mySearchedWagons = []

  $scope.showSelection = false
  $scope.labels = labels

  $scope.downloadInvoice = () => {
    const options = {
      invoice: $scope.myInvoice,
      wagons: $scope.mySelectedWagons,
    }
    excelLoader.invoice.download($scope.myInvoice.choice, options)
  }

  $scope.searchWagon = async () => {
    if (!valueHandler.isObject($scope.myInvoice) || !valueHandler.isObject($scope.myInvoice.owner) || !valueHandler.isId($scope.myInvoice.owner.id)) {
      return
    }

    const dateInterval = {
      dateBegin: utils.date.stringToServer($scope.myInvoice.dateBegin),
      dateEnd: utils.date.stringToServer($scope.myInvoice.dateEnd),
      ownerId: $scope.myInvoice.owner.id,
    }

    const response = await $$wagon.request.getInvoicable(dateInterval)

    $scope.mySearchedWagons = response.wagons
  }
}

export default invoicingCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/invoicing/invoicing.controller.js